import React from "react";
import { kozijnSettings } from "shared/utils/doorConfigurations";
import { MeshBasicMaterial } from "three";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import {
  DoorGlassMaterial,
  getFramePositions,
  getFrameScaling,
} from "../../../../../shared/utils/door";
import { defaultDoorWidth } from "shared/utils/doorSceneConstants";

import { store } from "shared/store/store";
import { useSnapshot } from "valtio";

interface KozijnProps extends kozijnSettings {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
  existingFrame: boolean;
}

const Kozijn: React.FC<KozijnProps> = ({
  doorNodes,
  materials,
  index,
  existingFrame,

  ...props
}: KozijnProps) => {
  const {
    getConfigurationHeight,
    getConfigurationWidth,
    getConfigurationColor,
  } = useConfigurationOptionsContext();

  const height = getConfigurationHeight(index);
  const width = getConfigurationWidth(index);

  const positions = getFramePositions(width, height, true);
  const scaling = getFrameScaling(width, height);

  const xScalingTop =
    width - defaultDoorWidth < 0
      ? scaling.horizontal.x +
        (1 - scaling.horizontal.x) * ((60 / width) * scaling.horizontal.x)
      : scaling.horizontal.x -
        (1 - scaling.horizontal.x) * ((30 / width) * scaling.horizontal.x);

  const snap = useSnapshot(store);
  const material = snap.activateKozijnColor
    ? materials[getConfigurationColor()]
    : existingFrame
      ? new MeshBasicMaterial({ color: "#FFF9DD" })
      : materials[getConfigurationColor()];

  return (
    <group>
      {props?.kozijnLeft?.enabled !== false && (
        <group scale-y={props?.kozijnLeft?.scaleY ?? 1}>
          <mesh
            geometry={doorNodes["kozijn_left"].geometry}
            material={material}
            scale={scaling.vertical}
            position={props?.rotateKozijn ? positions.right : positions.left}
          ></mesh>
        </group>
      )}
      {props?.kozijnRight?.enabled !== false && (
        <group scale-y={props?.kozijnRight?.scaleY ?? 1}>
          <mesh
            geometry={doorNodes["kozijn_right"].geometry}
            material={material}
            scale={scaling.vertical}
            position={props?.rotateKozijn ? positions.left : positions.right}
          ></mesh>
        </group>
      )}
      {props?.kozijnTop?.enabled !== false && (
        <mesh
          geometry={doorNodes["kozijn_top"].geometry}
          material={material}
          scale={[
            xScalingTop + 0.08,
            scaling.horizontal.y,
            scaling.horizontal.z,
          ]}
          position={positions.top}
        ></mesh>
      )}
    </group>
  );
};

export default Kozijn;
